import React from "react";
import Form from "react-bootstrap/esm/Form";

interface TextFormFieldProps {
  autoFocus?: boolean;
  label?: string;
  rows?: number;
  name: string;
  value: string;
  placeholder?: string;
  error?: string | false;
  onChange: (value: string) => void;
  onSubmitEditing?: () => void;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  errorRef?:
    | ((instance: HTMLElement | null) => void)
    | React.RefObject<HTMLElement>
    | null;
  inputRef?:
    | ((instance: HTMLInputElement | null) => void)
    | React.RefObject<HTMLInputElement>
    | null;
}

export function TextFormField(props: TextFormFieldProps) {
  const {
    label,
    rows,
    autoFocus,
    error,
    name,
    placeholder,
    value,
    onChange,
    onSubmitEditing,
    onBlur,
    errorRef,
    inputRef,
  } = props;

  return (
    <Form.Group controlId={name} className="text-form-field-v2">
      <Form.Label className="text-form-field-v2__label">{label}</Form.Label>
      {rows && rows > 1 ? (
        // Textarea input
        <Form.Control
          as="textarea"
          rows={rows}
          className="text-form-field-v2__input"
          autoFocus={autoFocus}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          onSubmitCapture={onSubmitEditing}
          onBlur={onBlur}
          isInvalid={!!error}
        />
      ) : (
        // Text input
        <Form.Control
          className="text-form-field-v2__input"
          autoFocus={autoFocus}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          onSubmitCapture={onSubmitEditing}
          onBlur={onBlur}
          isInvalid={!!error}
          ref={inputRef}
        />
      )}
      {!!error && (
        <Form.Text
          className="text-danger"
          ref={errorRef}
          data-testid={`${name}-error`}
        >
          {error}
        </Form.Text>
      )}
    </Form.Group>
  );
}
